import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const PaymentContext = createContext();

export function PaymentContextProvider({ children }) {
  const [paymentData, setPaymentData] = useState({
    paymentMethod: null,
    instalmentDetails: null,
  });

  PaymentContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };

  return (
  // eslint-disable-next-line react/jsx-filename-extension,react/jsx-no-constructed-context-values
    <PaymentContext.Provider value={[paymentData, setPaymentData]}>
      {children}
    </PaymentContext.Provider>
  );
}
